import React from 'react';
import { Icon } from '@chakra-ui/react';
import { FiArrowDown, FiArrowUp, FiMinus } from 'react-icons/fi';

export const TideTrend = (props) => {
    const { trend } = props;

    if (trend === 'increasing') {
        return <Icon as={FiArrowUp} color='green.500' mr={2} />
    } else if (trend === 'decreasing') {
        return <Icon as={FiArrowDown} color='red.500' mr={2} />
    }

    return <Icon as={FiMinus} color='gray.500' mr={2} />
};
